"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePath = normalizePath;
exports.joinPath = joinPath;
exports.resolvePath = resolvePath;
exports.dirnamePath = dirnamePath;
exports.basenamePath = basenamePath;
exports.extnamePath = extnamePath;
exports.isAbsolutePath = isAbsolutePath;
exports.relativePath = relativePath;
function normalizePath(path) {
    if (path.length === 0) {
        return '.';
    }
    const isAbsolute = path.startsWith('/');
    const trailingSlash = path.endsWith('/');
    const segments = path.split('/').filter((segment) => segment.length > 0);
    const resultSegments = [];
    for (const segment of segments) {
        if (segment === '.') {
            continue;
        }
        if (segment === '..') {
            if (resultSegments.length > 0 && resultSegments[resultSegments.length - 1] !== '..') {
                resultSegments.pop();
            }
            else if (!isAbsolute) {
                resultSegments.push('..');
            }
        }
        else {
            resultSegments.push(segment);
        }
    }
    let result = resultSegments.join('/');
    if (isAbsolute) {
        result = '/' + result;
    }
    if (trailingSlash && result !== '/' && resultSegments.length > 0) {
        result = result + '/';
    }
    if (result.length === 0) {
        return isAbsolute ? '/' : '.';
    }
    return result;
}
function joinPath(...paths) {
    if (paths.length === 0) {
        return '.';
    }
    const joined = paths.filter((p) => p.length > 0).join('/');
    return normalizePath(joined);
}
function resolvePath(cwd, ...paths) {
    let resolvedPath = '';
    for (let i = paths.length - 1; i >= 0; i--) {
        const path = paths[i];
        if (path.length === 0) {
            continue;
        }
        resolvedPath = resolvedPath.length > 0 ? path + '/' + resolvedPath : path;
        if (path.startsWith('/')) {
            return normalizePath(resolvedPath);
        }
    }
    if (cwd.length > 0) {
        resolvedPath = resolvedPath.length > 0 ? cwd + '/' + resolvedPath : cwd;
    }
    if (!resolvedPath.startsWith('/')) {
        resolvedPath = '/' + resolvedPath;
    }
    return normalizePath(resolvedPath);
}
function dirnamePath(path) {
    if (path.length === 0) {
        return '.';
    }
    const normalized = normalizePath(path);
    if (normalized === '/') {
        return '/';
    }
    const withoutTrailingSlash = normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;
    const lastSlashIndex = withoutTrailingSlash.lastIndexOf('/');
    if (lastSlashIndex === -1) {
        return '.';
    }
    if (lastSlashIndex === 0) {
        return '/';
    }
    return withoutTrailingSlash.slice(0, lastSlashIndex);
}
function basenamePath(path) {
    if (path.length === 0) {
        return '';
    }
    const normalized = normalizePath(path);
    if (normalized === '/') {
        return '';
    }
    const withoutTrailingSlash = normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;
    const lastSlashIndex = withoutTrailingSlash.lastIndexOf('/');
    if (lastSlashIndex === -1) {
        return withoutTrailingSlash;
    }
    return withoutTrailingSlash.slice(lastSlashIndex + 1);
}
function extnamePath(path) {
    const base = basenamePath(path);
    if (base.length === 0) {
        return '';
    }
    const dotIndex = base.lastIndexOf('.');
    if (dotIndex <= 0) {
        return '';
    }
    return base.slice(dotIndex);
}
function isAbsolutePath(path) {
    return path.startsWith('/');
}
function relativePath(from, to) {
    const normalizedFrom = normalizePath(from);
    const normalizedTo = normalizePath(to);
    if (normalizedFrom === normalizedTo) {
        return '';
    }
    const fromParts = normalizedFrom.split('/').filter((p) => p.length > 0);
    const toParts = normalizedTo.split('/').filter((p) => p.length > 0);
    let commonLength = 0;
    const minLength = Math.min(fromParts.length, toParts.length);
    for (let i = 0; i < minLength; i++) {
        if (fromParts[i] === toParts[i]) {
            commonLength++;
        }
        else {
            break;
        }
    }
    const upCount = fromParts.length - commonLength;
    const upParts = new Array(upCount).fill('..');
    const downParts = toParts.slice(commonLength);
    const result = [...upParts, ...downParts].join('/');
    return result.length > 0 ? result : '.';
}
//# sourceMappingURL=path-utils.js.map